import type {
  PublicMessagingState,
  SendContactWithPrescreenToAgentError,
  SendEmailToAgentError,
  SendScheduleTourRequestToAgentError,
} from './types'
import type { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { createSlice } from '@redux'

import {
  asyncActions,
  sendContactWithPrescreenToAgent,
  sendEmailToAgent,
  sendScheduleTourRequestToAgent,
} from './async-actions'
import { NAME } from './constant'

export const initialState: PublicMessagingState = {
  error: null,
  publicMessageStatus: 'initial',
  scheduleTourStatus: 'initial',
}

export const slice = createSlice(NAME, {
  name: NAME,
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<PublicMessagingState>): void => {
    builder.addCase(sendEmailToAgent.pending, (state) => {
      state.publicMessageStatus = 'pending'
      state.error = null
    })
    builder.addCase(sendEmailToAgent.fulfilled, (state) => {
      state.publicMessageStatus = 'fulfilled'
    })
    builder.addCase(sendEmailToAgent.rejected, (state, action) => {
      state.publicMessageStatus = 'rejected'
      state.error = action.payload as SendEmailToAgentError
    })
    builder.addCase(sendContactWithPrescreenToAgent.pending, (state) => {
      state.publicMessageStatus = 'pending'
      state.error = null
    })
    builder.addCase(sendContactWithPrescreenToAgent.fulfilled, (state) => {
      state.publicMessageStatus = 'fulfilled'
    })
    builder.addCase(sendContactWithPrescreenToAgent.rejected, (state, action) => {
      state.publicMessageStatus = 'rejected'
      state.error = action.payload as SendContactWithPrescreenToAgentError
    })
    builder.addCase(sendScheduleTourRequestToAgent.pending, (state) => {
      state.scheduleTourStatus = 'pending'
      state.error = null
    })
    builder.addCase(sendScheduleTourRequestToAgent.fulfilled, (state) => {
      state.scheduleTourStatus = 'fulfilled'
    })
    builder.addCase(sendScheduleTourRequestToAgent.rejected, (state, action) => {
      state.scheduleTourStatus = 'rejected'
      state.error = action.payload as SendScheduleTourRequestToAgentError
    })
  },
})

export const reducer = slice.reducer
export * from './selectors'

export const actions = {
  ...slice.actions,
  ...asyncActions,
}

export default { [NAME]: reducer }
